<template>
    <div>
        <span>{{ bp.name }}</span>

        <div v-for="(input, index) in bp.inputs" :key="'input-' + index">
            <button class="collapsible" @click="toggleCollapse($event)">
                <span class="arrow"></span> {{ input }}
            </button>
            <div class="content">
                <pre>{{ JSON.stringify(input, null, 2) }}</pre>
            </div>
        </div>

        <div v-for="(output, index) in bp.outputs" :key="'output-' + index">
            <button class="collapsible" @click="toggleCollapse($event)">
                <span class="arrow"></span> {{ output }}
            </button>
            <div class="content">
                <pre>{{ JSON.stringify(output, null, 2) }}</pre>
            </div>
        </div>
        <div v-for="(swi, index) in bp.switches" :key="'switch-' + index">
            <button class="collapsible" disabled>
                <span class="arrow"></span> {{ swi }}
            </button>
            <div class="content">
                <pre>{{ swi }}</pre>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "BreakpointLog",
    props: {
        Breakpoint: String,  // Expecting a stringified JSON object as prop
    },
    data() {
        return {
            bp: JSON.parse(this.Breakpoint),  // Parse the stringified JSON prop into an object
        };
    },
    mounted() {
    },
    methods: {
        toggleCollapse(event) {
            const button = event.currentTarget;
            const content = button.nextElementSibling;
            button.classList.toggle("active");

            if (content.style.maxHeight) {
                content.style.maxHeight = null;
            } else {
                content.style.maxHeight = content.scrollHeight + "px";
            }
        }
    }
}
</script>

<style scoped>
.collapsible {
  cursor: pointer;
  padding: 10px;
  width: 100%;
  border: none;
  text-align: left;
  outline: none;
  font-size: 15px;
  display: flex;
  align-items: center;
}

.collapsible:disabled:hover {
    background-color: #999;
    color: #000;
}
.collapsible:disabled {
    background-color: #999;
    color: #000;
}
.collapsible:hover {
  background-color: #888;
}

.arrow {
  margin-right: 10px;
  transition: transform 0.3s ease;
  content: '\25B6'; /* Right-pointing triangle */
}

.collapsible.active .arrow {
  transform: rotate(90deg); /* Rotate the arrow when active */
}

.content {
  padding: 0 18px;
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.2s ease-out;
  background-color: #f1f1f1;
}

.collapsible.active {
  background-color: #666;
}
</style>



// WEBPACK FOOTER //
// src/components/log/Breakpoint.vue